import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ss-table-export-button',
  templateUrl: './table-export-button.component.html',
  standalone: false
})
export class TableExportButtonComponent {
  @Input() disabled = false;
  @Output() exportRequested = new EventEmitter<void>();

  requestExport(event: Event): void {
    event.stopPropagation();
    this.exportRequested.emit();
  }
}
